import script from "./TaskStatusDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskStatusDetails.vue?vue&type=script&setup=true&lang=js"

import "./TaskStatusDetails.vue?vue&type=style&index=0&id=6059cba8&lang=scss"

const __exports__ = script;

export default __exports__